<div class="widget" [ngClass]="{'loader-shown': loading, 'initial': timeLeftToStart > 0 && !loading, 'failed-to-load': failedToLoad}">
  <div class="widget-failed-to-load" [attr.aria-hidden]="failedToLoad ? 'false' : 'true'">
    <div class="content">
      <div class="content-inner">
        <span class="icon material-icons" aria-hidden="true">priority_high</span>
        <h3 class="title">Error</h3>
        <p class="text-content">Unable to load data. Please try again.</p>
      </div>
      <button class="button button-secondary button-secondary--smaller" (click)="reloadWidget()" aria-label="Reload Widget">Reload</button>
    </div>
  </div>
  <div class="widget-loader widget-loader-eval-judge" [attr.aria-hidden]="loading ? 'false' : 'true'">
    <div class="widget-loader-header">
      <div class="loader-element loader-icon"></div>
      <div class="loader-element loader-title"></div>
    </div>
    <div class="widget-loader-content">
      <div class="arc-loading"></div>
      <div class="loader-element image-loading"></div>
      <div class="loader-element small-loading"></div>
      <div class="loader-element button-loading"></div>
    </div>
  </div>
  <div class="widget-header" [attr.aria-hidden]="failedToLoad ?? loading ? 'true' : 'false'">
    <span class="custom-icon" aria-hidden="true">
      <span class="icon material-icons">how_to_reg</span>
    </span>
    <span class="title">{{ stageName }}</span>
  </div>
  <div class="widget-content" [attr.aria-hidden]="failedToLoad ?? loading ? 'true' : 'false'">
    <div *ngIf="!stageId">Not connected to a stage</div>

    <div *ngIf="stageId && timeLeftToStart > 0" class="default-state">
      <img src="assets/images/widget/peer-review.png"/>
      <span class="inner-title">{{ timeLeftToStartCalculated }} {{ timeLeftString }}</span>
      <span class="inner-message">left until {{ stageName }} begins</span>
    </div>

    <div *ngIf="stageId && timeLeftToStart <= 0 && !isDeadlinePassed" class="reviews">

      <div class="arc">
        <div [style]="calculatedArcStyle"></div>
      </div>

      <div class="text" [attr.aria-label]="completedReviews + ' completed reviews out of ' + neededReviews + ' needed reviews'">
        <span>{{ completedReviews }}</span>
        <span>OUT OF {{ neededReviews }}</span>
      </div>

    </div>

    <div *ngIf="stageId && timeLeftToStart <= 0 && isDeadlinePassed" class="custom-message">
      <span class="icon material-icons submitted" aria-hidden="true">check_circle</span>
      <small>Thank you for your contribution in assessing applications. Your time, expertise, and thoughtful evaluations have made a significant impact and will help us make informed decisions.</small>
    </div>

    <button class="button button-primary" *ngIf="stageId && timeLeftToStart <= 0" [routerLink]="buttonLink">         
      {{ buttonText }}
    </button>

  </div>
</div>